import { Box, Grid, Stack, Typography } from '@mui/material'
import RecentFilesComponent from '../components/Architecture/RecentFilesComponent'
import StartNewFileComponent from '../components/Architecture/StartNewFileComponent'
import RecentProjectsLinkComponent from '../components/Architecture/RecentProjectsLinkComponent'

function Home() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Grid container spacing='1rem'>
        <Grid size={3}>
          <Stack gap='1rem'>
            <Box display='flex' width='100%'>
              <Typography
                sx={{
                  color: '#06004A',
                  fontSize: '0.94rem',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}
              >
                Home
              </Typography>
            </Box>
            <StartNewFileComponent />
          </Stack>
        </Grid>
        <Grid size={9}>
          <Stack gap='1rem'>
            <Box
              display='flex'
              justifyContent='space-between'
              alignItems='center'
              width='100%'
            >
              <Typography
                sx={{
                  color: '#06004A',
                  fontSize: '0.94rem',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}
              >
                Recent Projects
              </Typography>
              <RecentProjectsLinkComponent />
            </Box>
            <RecentFilesComponent />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Home
